(function () {

    "use strict";

    angular
        .module('userActivation')
        .controller("EmailActivationModal", EmailActivationModal);

    EmailActivationModal.$inject = ['$scope', '$stateParams', '$state', 'userActivationService', '$filter'];

    function EmailActivationModal($scope, $stateParams, $state, userActivationService, $filter) {
        var self = this;
        self.loading = true;
        userActivationService.getUserSecondaryInfoByCode($stateParams.code).then(function (res) {
            self.emailActivationForm = new EmailActivationForm($scope, userActivationService);
            var user_info = res['user_info'];
            user_info['code'] = $stateParams.code;
            self.emailActivationForm.load(user_info);
            self.loading = false;
        }, function (error) {
            error = error && error['data'] && error['data']['data'];
            if (error && error['code'] && error['code']['ALREADY_ACTIVATED']) {
                self.close();
            } else if (error && error['code'] && error['code']['INVALID_CODE']) {
                self.close();
            } else {
                var title = $filter("translate")("Wrong Link");
                var message = $filter("translate")("Please refer to the link you've received on your email.");
                hAlert(title, message, function () {
                    self.close();
                });
            }
        });

        self.close = function () {
            $scope.$hide();
            Utils.redirectToWorkspace('homepage');
        };

        self.save = function () {
            self.emailActivationForm.save().then(function () {
                var title = $filter("translate")("Congratulations!");
                var message = $filter("translate")("Your account password has been set");
                hAlert(title, message, function () {
                    self.close();
                });
            }, function (error) {
                var title = $filter("translate")("Something Went Wrong");
                var message = $filter("translate")("Something Went Wrong");
                hAlert(title, message, function () {
                    self.close();
                });
            });
        };

    }

})();
